module.exports = __webpack_public_path__ + "img/y- (10).910b7871.jpg";